import { render, staticRenderFns } from "./SituationAutoevaluation.vue?vue&type=template&id=6df987d3&"
import script from "./SituationAutoevaluation.vue?vue&type=script&lang=js&"
export * from "./SituationAutoevaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports